import * as React from "react";
import type { SVGProps } from "react";
const SvgNextArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#18A09F"
      fillRule="evenodd"
      d="M15.293.293a1 1 0 0 1 1.414 0l9 9a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-1.414-1.414L22.586 11H1a1 1 0 1 1 0-2h21.586l-7.293-7.293a1 1 0 0 1 0-1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNextArrow;
